import styled from 'styled-components';
import { FooterHeight, SubFooterHeight } from '../../../const';
import { Container } from '../../gridSystem';

export const FootContainer = styled.footer`
  position: relative;
  display: block;
  background-color: ${(props) => props.theme.colors.bgFooter};
  z-index: ${(props) => props.theme.zIndex.foot};
  padding: 40px 48px;

  height: calc(${FooterHeight}px + ${SubFooterHeight}px);
  min-height: calc(100% + 72px);
  width: 100%;

  & span {
    margin-left: 0;
  }

  @media ${(props) => props.theme.device.tablet} {
    height: calc(${FooterHeight}px + ${SubFooterHeight}px + 50px);
  }

  @media ${(props) => props.theme.device.mobileL} {
    padding: 40px 24px 0;
    height: fit-content;
    min-height: ${FooterHeight}px;
  }

  .footer-link {
    transition: ${(props) => props.theme.constants.transitionBase};
    color: ${(props) => props.theme.colors.white};
    text-decoration: underline;

    &:hover,
    &:focus {
      color: ${(props) => props.theme.colors.white};
      text-decoration: none;
    }
  }
`;

export const FootContent = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
  color: ${(props) => props.theme.colors.white};

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    margin: 0;
    padding: 0;
    gap: 40px;
    padding-bottom: 40px;
  }
`;

export const Icon = styled.span`
  margin-left: 15px;
`;

export const FooterSection = styled.div`
  .footer-title {
    text-transform: uppercase;
  }

  &.logo_carousel {
    @media ${(props) => props.theme.device.mobileL} {
      margin: auto;
    }
  }
`;

export const Link = styled.a`
  color: ${(props) => props.theme.colors.white};
  transition: ${(props) => props.theme.constants.transitionBase};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }

  .gt {
    font-size: 14px;
  }
`;

export const LogosSection = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 50px 25px;
  align-items: center;

  > div {
    max-height: unset;
    img {
      width: 100%;
      height: auto;
    }
    &:first-child {
      grid-column-start: 1;
      grid-column-end: 5;
      width: 100%;
      max-width: 285px;
    }
    &:not(:first-child) {
      width: 130px;
      height: auto;
    }
  }

  @media ${(props) => props.theme.device.mobileL} {
    grid-template-columns: repeat(2, 1fr) !important;

    > div {
      &:first-child {
        grid-column-start: 1;
        grid-column-end: 3;
      }
    }
  }
`;

export const LinkSection = styled.div`
  display: flex;
  flex-direction: column;
  > * {
    margin-bottom: 5px;
  }
`;

export const SocialSection = styled.div`
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 30px;
  max-width: 110px;
  svg {
    fill: ${(props) => props.theme.colors.white} !important;
    stroke: ${(props) => props.theme.colors.white};
  }
`;

export const ContactSection = styled.div`
  color: ${(props) => props.theme.colors.gray};
  margin-top: 40px;

  div:not(:last-child) {
    margin-bottom: 5px;
  }
`;

export const SubFooter = styled.div`
  padding: 0 48px;
  height: ${SubFooterHeight}px;
  background-color: ${(props) => props.theme.colors.bgSubFooter};
  position: absolute;
  bottom: 0;
  left: 0;
  width: inherit;

  @media ${(props) => props.theme.device.mobileL} {
    width: var(--full-width);
    position: relative;
    margin-left: -24px;
    padding: 24px;
    height: fit-content;
  }
`;

export const SubFooterContainer = styled(Container)`
  display: flex;
  align-items: center;
  gap: 48px;
  width: 100%;
  height: inherit;
  color: ${(props) => props.theme.colors.white};

  span {
    font-weight: 700;
  }

  > div:last-child {
    margin-left: auto;
  }

  @media ${(props) => props.theme.device.mobileL} {
    gap: 8px;
    column-gap: 38px;
    flex-wrap: wrap;

    > a > div {
      margin-bottom: 0;
      text-decoration: none;
    }
  }
`;

export const LogosWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  max-width: 60%;
  align-items: center;
  gap: 20px;

  @media ${(props) => props.theme.device.mobileL} {
    max-width: 100%;
    grid-template-columns: repeat(2, 1fr) !important;
  }
`;
